import { render, staticRenderFns } from "./JoinContract.vue?vue&type=template&id=7083219e&scoped=true"
import script from "./JoinContract.vue?vue&type=script&lang=js"
export * from "./JoinContract.vue?vue&type=script&lang=js"
import style0 from "./JoinContract.vue?vue&type=style&index=0&id=7083219e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7083219e",
  null
  
)

export default component.exports